import { useState } from "react";
import { Dropdown } from "../../components/ui/dropdown";
import { useToast } from "../../components/ui/toast";
import { cn } from "../../lib/utils";
import { TIMEZONE_OPTIONS } from "../settings/types";

export function GeneralTab({ orgName, orgTimezone, onSave }: {
  orgName: string; orgTimezone: string;
  onSave: (name: string, tz: string) => void;
}) {
  const toast = useToast();
  const [name, setName] = useState(orgName);
  const [tz, setTz] = useState(orgTimezone);
  const dirty = name !== orgName || tz !== orgTimezone;

  return (
    <div className="space-y-6">
      <div className="rounded-xl shadow-card dark:shadow-card-dark bg-paper-card dark:bg-[#292524] p-4 sm:p-5">
        <h2 className="text-sm font-semibold text-ink">Workspace Profile</h2>
        <div className="mt-4 space-y-4">
          <label className="block">
            <span className="mb-1 block font-mono text-[10px] font-semibold uppercase tracking-wider text-ink-3">Organization Name</span>
            <input
              value={name} onChange={(e) => setName(e.target.value)}
              className="w-full rounded-lg border border-line px-3 py-2.5 text-sm text-ink focus:border-brand focus:outline-none focus:ring-2 focus:ring-brand/30"
            />
          </label>
          <label className="block">
            <span className="mb-1 block font-mono text-[10px] font-semibold uppercase tracking-wider text-ink-3">Workspace ID</span>
            <input
              value="org_JFggadvR8AWEI897" 
              disabled
              className="w-full rounded-lg border border-line px-3 py-2.5 text-sm text-ink-3 bg-soft/50 cursor-not-allowed"
            />
          </label>
          <div>
            <span className="mb-1 block font-mono text-[10px] font-semibold uppercase tracking-wider text-ink-3">Timezone</span>
            <Dropdown ariaLabel="Default timezone" value={tz} options={TIMEZONE_OPTIONS} onChange={setTz} className="w-64" />
          </div>
          <button
            disabled={!dirty}
            onClick={() => { onSave(name, tz); toast.success("Workspace settings saved"); }}
            className={cn("rounded-lg px-4 py-2.5 text-sm font-semibold text-white", dirty ? "bg-brand hover:bg-brand-hover" : "cursor-not-allowed bg-line text-ink-3")}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}
